<template>
  <div class="absolute z-1" :class="captionPosition && positionMapping[captionPosition]">
    <cms-rich-text
      v-if="captionUseHtml"
      v-style:c="captionColor"
      :class="{ 'mx-6 my-3': !alignWithOverlay }"
      :content="{ richText: captionHtml! }"
    />
    <div
      v-else
      v-style:c="captionColor"
      :class="[captionStyle, { 'mx-6 my-3': !alignWithOverlay }]"
      style="max-width: 9.375rem"
    >
      {{ captionText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { CaptionPosition, StyledCaption } from '#types/styles'
import { CmsRichText } from '#components'

const {
  captionColor,
  captionPosition,
  captionStyle,
  captionText,
  captionHtml,
  captionUseHtml,
  alignWithOverlay,
} = defineProps<StyledCaption>()

const positionMapping: Record<CaptionPosition, string> = {
  'bottom-center': 'bottom-0 left-1/2 -translate-x-1/2',
  'bottom-left': 'bottom-0 left-0',
  'bottom': 'bottom-0 right-0',
  'middle-left': 'top-1/2 left-0 -translate-y-1/2',
  'middle-center': 'top-1/2 left-1/2 -translate-1/2',
  'middle-right': 'top-1/2 right-0 -translate-y-1/2',
  'top-center': 'top-0 left-1/2 -translate-x-1/2',
  'top-left': 'top-0 left-0',
  'top': 'top-0 right-0',
}
</script>
